export const productTreeCacheKey = (ProductGroupUUID: string) => ['SUPPORT', 'ProductTree', ProductGroupUUID]
